import * as React from 'react';
import { AsideContacts } from '../AsideContacts';
import { Layout } from '../Layout';
import { PriceContainer } from '../../containers/Price';
import { BuilderContainer } from '../../containers/Builder';
import { StickyBlock } from '../StickyBlock';
import { RightPromoContainer } from '../../containers/RightPromoContainer';
import { RightReliableLabelContainer } from '../../containers/RightReliableLabel';
import { SecondaryContactButtonsContainer } from '../../containers/SecondaryContactButtons';
import { WorkTimeInfoContainer } from '../../containers/WorkTimeInfo';
import { UpcomingSaleRequestFormContainer } from '../../containers/UpcomingSaleRequestFormContainer';
import { ActionButtonContainer } from '../../containers/ActionButton';
import { BrokerButtonContainer } from '../../containers/BrokerButton';

export interface IRightColumnProps {
  dynamicCalltrackingPlaceType: string;
  isLeadFactory?: boolean;
  isUpcomingSale?: boolean;
}

export const RightColumn: React.FunctionComponent<IRightColumnProps> = props => {
  const { dynamicCalltrackingPlaceType, isLeadFactory, isUpcomingSale } = props;

  if (isUpcomingSale) {
    return (
      <StickyBlock top={102}>
        <Layout fullwidth>
          <UpcomingSaleRequestFormContainer />
        </Layout>
      </StickyBlock>
    );
  }

  return (
    <StickyBlock top={102}>
      <Layout fullwidth>
        <RightPromoContainer />
        <PriceContainer />
        <BuilderContainer />
        <AsideContacts isLeadFactory={isLeadFactory}>
          <BrokerButtonContainer />
          <ActionButtonContainer
            dynamicCalltrackingPlaceType={dynamicCalltrackingPlaceType}
            analyticOnOpenActionName="Open_jk_card_blockJK"
            fullWidth
            XXL
          />
          <SecondaryContactButtonsContainer />
          <WorkTimeInfoContainer />
        </AsideContacts>
        <RightReliableLabelContainer />
      </Layout>
    </StickyBlock>
  );
};
